@if (header) {
    <div class="agpr-autocomplete-chips-header">
        <label
            [id]="id + '_autocompleteChips_autocompleteLabel'"
            class="agpr-autocomplete-chips-header-label"
            [ngClass]="headerStyleClass"
        >
            {{ header | localize }}
        </label>
    </div>
}

@if (value) {
    <div
        class="agpr-autocomplete-chips"
        [class.agpr-autocomplete-chips--hasChips]="value && value.length > 0"
    >
        <div class="agpr-autocomplete-chips-inputRow">
            <agpr-autocomplete
                #autocomplete
                [id]="id + '.autocomplete'"
                [style]="style"
                [class.agpr-autocomplete-chips-autocomplete--withButton]="button"
                [flatBottomRight]="value && value.length > 0"
                [placeholder]="placeholder ? (placeholder | localize) : undefined"
                [disabled]="disabled"
                [labelField]="field"
                [valueForSuggestions]="value"
                [selectedItemsHideKey]="selectedItemsHideKey"
                [suggestionsFetcher]="autocompleteOptions?.suggestionsFetcher"
                [dropdown]="autocompleteOptions?.dropdown ?? false"
                [customOptions]="autocompleteOptions?.customOptions ?? []"
                [forceSelection]="autocompleteOptions?.forceSelection"
                [clearOnBlur]="autocompleteOptions?.clearOnBlur ?? true"
                [minLength]="autocompleteOptions?.minLength ?? 3"
                [delay]="autocompleteOptions?.delay ?? 300"
                (itemSelected)="addChip($event)"
                (onKeyUp)="autocompleteKeyUp($event)"
                (blur)="blur.emit($event)"
                [ariaLabel]="ariaLabel"
                [ariaLabelledBy]="ariaLabelledBy ? ariaLabelledBy : (header ? id + '_autocompleteChips_autocompleteLabel' : '')"
                [ariaDescribedBy]="(value && value.length > 0 ? id + '_chips ' : '') + (id + '_errors ') + ariaDescribedBy"
                [ariaInvalid]="ariaInvalid || chipValidationErrors.length > 0"
                [required]="required"
                [showHiddenOption]="showHiddenOption"
                [itemTemplate]="itemTemplate"
            ></agpr-autocomplete>

            @if (button) {
                <agpr-button
                    class="agpr-autocomplete-chips-button"
                    [class.agpr-autocomplete-chips-button--hasChips]="value && value.length > 0"
                    [icon]="button.icon"
                    [disabled]="disabled"
                    [style]="buttonTypes.block"
                    [tooltip]="button.tooltip ? (button.tooltip | localize) : undefined"
                    tooltipPosition="top"
                    (click)="buttonPress.emit()"
                    [ariaLabel]="button.tooltip | localize"
                >
                    {{ button.text ? (button.text | localize) : '' }}
                </agpr-button>
            }
        </div>
        @if (value && value.length > 0) {
            <agpr-chips
                [id]="id + '_chips'"
                [(ngModel)]="value"
                (ngModelChange)="onModelChange(value)"
                [labelFieldName]="field"
                [clearAllChipsTooltip]="clearAllChipsTooltip"
                [style]="style"
                [disabled]="disabled"
                [ariaLabelledBy]="ariaLabelledBy ? ariaLabelledBy : (header ? id + '_autocompleteChips_autocompleteLabel' : '')"
                (allChipsRemoved)="clearAllChips($event)"
            ></agpr-chips>
        }
    </div>
}

<ul [id]="id + '_errors'">
    @for (error of chipValidationErrors; track error) {
        <li>
            <agpr-form-message>
                {{ error | localize }}
            </agpr-form-message>
        </li>
    }
</ul>

